import { SPREEDLY_PLATFORM_TYPE, YOURPAY_PLATFORM_TYPE } from './card-type-names';

const env = global.pbgEnv;
const { REACT_APP_DISABLED_CARD_FIELDS } = env;

export const extractCardExpirationParts = exp => {
  if (typeof exp !== 'string') {
    return { month: '', year: '' };
  }
  const value = exp
    .replace(/\//g, '')
    .replace(/\D/g, '')
    .slice(0, 4);
  if (value.length < 3) return { month: value };

  const parts = value.split('');
  return {
    month: parts.slice(0, 2).join(''),
    year: parts.slice(2).join(''),
  };
};

export const normalizeExpirationDate = currentValue => {
  const hasEndingSlash = /.*\/$/.test(currentValue);
  const parts = extractCardExpirationParts(currentValue);
  if (!parts.year) return hasEndingSlash ? `${parts.month}/` : parts.month;
  return [parts.month, parts.year].join('/');
};

const buildCard = card => {
  const exp = extractCardExpirationParts(card.expDate);

  return {
    full_name: card.fullName,
    month: exp.month,
    year: `20${exp.year}`,
    zip: card.zipCode,
  };
};

export const tokenizeCard = (props, email, paymentPlatform) => {
  if (paymentPlatform.type === SPREEDLY_PLATFORM_TYPE) {
    window.Spreedly.tokenizeCreditCard({
      ...buildCard(props),
      email,
    });
  }

  if (paymentPlatform.type === YOURPAY_PLATFORM_TYPE) {
    window.YourPay.tokenizeCard({
      ...buildCard(props),
      email,
    });
  }
};

export const expirationDateValid = expParts => {
  if (!expParts.month || !expParts.year) return false;

  const currentMonth = new Date().getMonth();
  const currentYear = parseInt(
    new Date()
      .getFullYear()
      .toString()
      .substr(2, 2),
    10
  );
  const creditCardMonth = parseInt(expParts.month, 10);
  const creditCardYear = parseInt(expParts.year, 10);

  if (creditCardYear === currentYear && creditCardMonth < currentMonth) return false;

  const monthValid = creditCardMonth >= 1 && creditCardMonth <= 12;
  const yearValid = creditCardYear >= currentYear;

  return monthValid && yearValid;
};

export const isMonthInvalid = ({ month }) => {
  const creditCardMonth = parseInt(month, 10);
  return creditCardMonth < 1 || creditCardMonth > 12;
};

export const isExpired = dateString => {
  const [month, year] = dateString.split('/');
  const today = new Date();
  const cardDate = new Date();
  cardDate.setFullYear(parseInt('20' + year, 10), parseInt(month, 10), 1);
  return cardDate < today;
};

export const disabledCardFields = merchant => {
  if (!REACT_APP_DISABLED_CARD_FIELDS || !merchant) return [];
  const json = atob(REACT_APP_DISABLED_CARD_FIELDS);
  return JSON.parse(json)[merchant.uniqueName] || [];
};

const YourPay = window.YourPay;
export const initializeYourPay = ({ config, onRemoteFieldChange, onSuccess, onError }) => {
  YourPay.init(config.merchantid, {
    numberEl: 'card-field',
    cvvEl: 'cvv-field',
  });
  YourPay.setStyle('number', 'font-size: 14px; color: #555; width: 100%; padding-left: 35px;');
  YourPay.setStyle('cvv', 'font-size: 14px; color: #555; width: 100%;');

  YourPay.on('fieldEvent', onRemoteFieldChange);
  YourPay.onCardTokenized(onSuccess);
  YourPay.onCardError(onError);
};

const Spreedly = window.Spreedly;

export const validateSpreedly = () => Spreedly.validate();

export const initializeSpreedly = ({ config, onRemoteFieldChange, onSuccess, onError, onValidation, fieldStyles }) => {
  Spreedly.on('ready', () => {
    Spreedly.setFieldType('number', 'text');
    Spreedly.setNumberFormat('prettyFormat');
    Spreedly.setStyle('number', fieldStyles || 'font-size: 14px; color: #555; width: 100%; padding-left: 35px;');
    Spreedly.setStyle('cvv', fieldStyles || 'font-size: 14px; color: #555; width: 100%;');
  });

  if (onRemoteFieldChange) Spreedly.on('fieldEvent', onRemoteFieldChange);

  Spreedly.init(config.spreedlyKey, {
    numberEl: 'card-field',
    cvvEl: 'cvv-field',
  });

  if (onSuccess) {
    Spreedly.on('paymentMethod', (token, paymentMethod) => {
      Spreedly.reload();
      onSuccess(token, paymentMethod);
    });
  }

  if (onError) Spreedly.on('errors', onError);
  if (onValidation) Spreedly.on('validation', onValidation);
};

export const isNumberChangedEvent = (type, name) => type === 'input' && name === 'number';
export const isCvvChangedEvent = (type, name) => type === 'input' && name === 'cvv';



// WEBPACK FOOTER //
// ./src/lib/card-functions.js